import React from "react";
import { Header, Sidebar, AuthenticateDashboard , NewSidebar} from "../../common";
import { Outlet } from "react-router-dom";

const Dashboard = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="dashboard flex flex-grow ">
        {/* <Sidebar /> */}
        <NewSidebar />
        <Outlet />
      </div>
    </div>
  );
};

export default AuthenticateDashboard(Dashboard);
